import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChess } from '@fortawesome/free-solid-svg-icons';

const SettingsView: React.FC = () => {
    return (
        <Container fluid className="h-100 d-flex align-items-center justify-content-center">
            <Row>
                <Col className="text-center text-muted">
                    <FontAwesomeIcon icon={faChess} size="4x" className="mb-3" />
                    <h3>Game Settings</h3>
                    <p>Settings functionality coming soon...</p>
                </Col>
            </Row>
        </Container>
    );
};

export default SettingsView;
